
import { useDebounce } from '@uidotdev/usehooks'
import { useNavigate } from '@tanstack/react-router'
import { useTranslations } from '@/hooks/useTranslations'
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Loader } from '@/components/common/Loader'
// import { useConfirmDeleteUserModal, useConfirmInviteModal, useInvitedWarningModal } from '@/components/common/Modals'
import { toast } from '@/components/common/Toast'
import { Button, LinkButton } from '@/components/ui'
import { UserDropdown, UserOrganizationStatus } from '@/constants/user'
// import {
//   useDeleteUserOrganization,
//   useGetOrganizationUserList,
//   useResendInviteUserOrganization,
// } from '@/modules/user/services/user'

import { useDatatableHeaders } from './columns'
// import { useConfirmDownloadModal } from '@/components/common/Modals/ConfirmDownloadModal'
import { useDataTable } from '@/hooks/useDataTable'
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@/constants/datatable'
import { DataTable } from '@/components/common/DataTable/DataTable'
import { useDeleteUser } from '@/modules/user/services/user'
import { useDeleteRole, useGetRoleList } from '@/modules/role/services/role'


export const RoleManagementList = () => {
  const t = useTranslations('admin.role_management')
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState<string>(UserOrganizationStatus.ALL)
  const debouncedSearchTerms = useDebounce(search, 500)
  const [searchTerms, setSearchTerms] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const $apiDeleteRole = useDeleteRole()
  // const $apiDeactivateUser = useDeactivateUser()

  const onClickUserDropdownEvent = useCallback(
    async (eventName: string, role: any) => {
      switch (eventName) {
        case UserDropdown.EDIT:
          navigate({ to: `/admin/role/${role.id}/edit` })
          break
        // case UserDropdown.VIEW:
        //   navigate({ to: `/` })
        //   break
        case UserDropdown.DELETE:
          await $apiDeleteRole.mutateAsync({ id: role.id });
          toast.toastSuccess('ลบบทบาทสำเร็จ')
          break
        // case UserDropdown.STATUS:
        // $apiDeactivateUser.mutateAsync(user.user_id, user.status);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  const { columns } = useDatatableHeaders({ search: searchTerms, onClickUserDropdownEvent })

  const { dataTableProps, state, setData, setTotalPages, setPagination } = useDataTable({
    columns,
    showPageSize: true,
    showPagination: true,
    isLoading: false,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    sorting: [
      {
        id: 'created_at',
        desc: true,
      },
    ],
  })

  const { data, isPending } = useGetRoleList({
    page: state.pagination.page,
    pageSize: state.pagination.pageSize,
    search: searchTerms,
    status,
    sort: state.sorting,
  })

  useEffect(() => {
    setSearchTerms(debouncedSearchTerms)
  }, [debouncedSearchTerms])

  useEffect(() => {

    setData(data?.data ?? [])
    setTotalPages(data?.meta?.totalPages ?? 1)
  }, [data, setData, setTotalPages])

  useEffect(() => {
    setPagination({ pageIndex: 0, pageSize: state.pagination.pageSize })
  }, [search, status])

  const isHasFilter = !!search || status !== UserOrganizationStatus.ALL

  return (
    <Fragment>
      <div className="relative">
        <div className="relative mt-4 p-4 md:p-8">
          <DataTable
            {...dataTableProps}
            isFilter={isHasFilter}
            isLoading={isPending}
          />
        </div>
        {isLoading && <Loader.FullScreen />}
      </div>
    </Fragment>
  )
}
